<template>
    <div>
        <div class="com-model top-model m-b-15">
            <div class="top-bar  m-b-20">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item :to="{ path: '/index/finance' }">财务管理</el-breadcrumb-item>
                    <el-breadcrumb-item>发票管理</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <div class="top-content flex">
                <div class="left-box">
                    <div class="cont-title">可索取发票金额</div>
                    <div class="money">¥ {{invoiceDetail.invoiceAmount}}</div>
                    <div class="flex">
                        <router-link to="/index/finance/invoice/info" class="primary-btn">索取发票</router-link>
                        <div class="tip">温馨提示：请在充值后30个工作日内申请开具发票</div>
                    </div>
                </div>
                <div class="right-box">
                    <div class="cont-title">发票信息</div>
                    <p>默认抬头：{{invoiceDetail.invoiceTitle || hrinfo.companyName}}</p>
                    <p style="margin-bottom: 12px">开具类型：企业增值税普通发票</p>
                    <!-- <div class="primary-btn">管理发票信息</div> -->
                </div>
            </div>
        </div>
        <div class="com-model list-model">
            <div class="flex m-b-18">
                <div class="label">发票申请时间</div>
                <div class="value">
                    <el-date-picker
                    v-model="dateTimeRange"
                    type="datetimerange"
                    placeholder="选择时间范围" @change="handleChange">
                    </el-date-picker>
                </div>
                <!-- <div class="primary-btn" @click="handleSearch">搜索</div> -->
            </div>
            <el-table
            :data="list"
            @filter-change="fileterChange"
            style="width: 100%">
                <el-table-column
                prop="createdAt"
                label="申请时间"
                width="180">
                </el-table-column>
                <el-table-column
                prop="invoiceTitle"
                label="发票抬头">
                </el-table-column>
                <el-table-column
                prop="invoiceAmount"
                label="发票总额" width="120">
                </el-table-column>
                <el-table-column
                prop="status"
                label="发票状态"
                width="120"
                column-key="status"
                :filters="statusFilters"

                filter-placement="bottom-end">
                <template slot-scope="scope">
                    <span>{{status[scope.row.status]}}</span>
                </template>
                </el-table-column>
                 <el-table-column
                prop="remark"
                label="驳回原因">
                </el-table-column>
            </el-table>
             <el-pagination
                v-show="total"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageNum"
                :page-sizes="[5, 10, 20, 30, 40]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total" style="margin-top: 40px; padding-bottom: 40px">
            </el-pagination>
        </div>
    </div>
</template>
<script>
export default {
    data () {
        return {
            dateTimeRange: [],
            pageNum: 1,
            pageSize: 10,
            total: null,
            statusList: [],
            list: [],
            status: {1: '已申请', 2: '已审核', 3: '已开票', 0: '已拒绝'},
            statusFilters: [{text: '已申请', value: 1}, {text: '已审核', value: 2}, {text: '已开票', value: 3}, {text: '已拒绝', value: 0}],
            hrinfo: {},
            invoiceDetail: {}
        }
    },
    mounted () {
        this.getList()
        this.getInfo()
        this.hrinfo = this.$store.state.hrinfo
    },
    methods: {
        getList () {
            let params = {
                pageNum: this.pageNum,
                pageSize: this.pageSize,
                startTime: this.dateTimeRange[0],
                endTime: this.dateTimeRange[1],
                statusList: this.statusList
            }
            this.axios.post('/wapi/company/invoice/get', params).then(res => {
                if (res.code == 200) {
                    this.list = res.rows;
                    this.total = res.total;
                }
            })
        },
        getInfo() {
            this.axios.get('/wapi/company/invoice/overview').then(res => {
                if (res.success) {
                    const data = res.data;
                    this.invoiceDetail = {
                        invoiceAmount: data.canInvoiceAmount,
                        invoiceTitle: data.lastInvoiceTitle
                    }
                }
            })
        },
        handleChange (val) {
            this.pageNum = 1;
            this.getList()
        },
        handleSizeChange(val){
            this.pageSize = val;
            this.getList()
        },
        handleCurrentChange(val){
            this.pageNum = val;
            this.getList()
        },
        fileterChange (val){
            this.statusList = val.status;
            this.pageNum = 1;
            this.getList()
        }
    }
}
</script>
<style lang="less" scoped>
@import "../../assets/less/base.less";
.com-model {
    border-radius: 10px;
}
.top-model{
    padding: 24px;
}
.top-content{
    height: 197px;
    border-radius: 2px;
    border: 1px solid #E6E6E6;
    padding: 33px 32px 21px;
    box-sizing: border-box;
    .cont-title{
        font-size: 16px;
        font-weight: 400;
        color: #555555;
        line-height: 22px;
        margin-bottom: 8px;
    }
    .money{
        font-size: 30px;
        font-weight: 500;
        color: rgba(0,0,0,0.85);
        line-height: 42px;
        margin-bottom: 24px;
    }
    .primary-btn{
        padding: 0 30px;
    }
    p{
        font-size: 16px;
        font-weight: 400;
        color: #555555;
        line-height: 22px;
        margin-bottom: 8px;
    }
    .left-box, .right-box{
        width: 50%;
    }
    .left-box{
        border-right: 1px dotted #E9E9E9;
    }
    .right-box{
        padding-left: 40px;
    }
    .tip{
        width: 166px;
        font-size: 14px;
        font-weight: 400;
        color: #96BADF;
        line-height: 20px;
        margin-left: 30px;
    }
}
.list-model{
    padding: 22px 25px 60px;
    .label{
        font-size: 16px;
        color: #333333;
        margin-right: 24px;
    }
}
</style>



// WEBPACK FOOTER //
// invoiceList.vue?7458f6d5